import { baseTemplateParams } from '../shared/baseParams.js'

export const defaultTemplateParams = {
  ...baseTemplateParams,
  headerBgColor: '#F8F8F3',
  emailTitle: 'The Journey Begins',
  ctaText: 'Explore offers',
  ctaBackgroundColor: '#111827',
  ctaTextColor: '#000000',
  preheaderText: 'Thank you for joining us — your next stay awaits.',
  subject: 'Welcome — your journey begins',
  selectedTemplate: 'cinematicConfirm',
  shellTemplateKey: 'cinematicConfirm',
  logoWidth: '220px',
  logoHeight: '44px',
  hotelName: '',
  hotelAddress: '',
  hotelCityStateZip: '',
  hotelPhone: '',
  hotelWebsite: '',
  hotelWebsiteUrl: '',
  richtextFields: {
    ...baseTemplateParams.richtextFields,
    bodyHtml: `Hello :token{key="guestName" label="First name"},

Thank you for embarking with us on a voyage of discovery. We look forward to inspiring your future travels and sharing exclusive offers and the latest news with you.`
  }
}

export default defaultTemplateParams
